// ===================================================
// ФАЙЛ: frontend/src/pages/Auth/ForgotPassword.jsx
// Восстановление пароля перенесено в Маркбэйс id (auth.markbase.ru).
// Эта страница только перенаправляет пользователя в единый центр аутентификации.
// ===================================================
import React, { useEffect } from 'react';
import { Spin } from 'antd';

const getUamUrl = () => {
  const raw = process.env.REACT_APP_UAM_URL || 'https://auth.markbase.ru';
  return raw.replace(/\/+$/, '');
};

const ForgotPassword = () => {
  useEffect(() => {
    const returnUrl = `${window.location.origin}/login`;
    window.location.replace(`${getUamUrl()}/reset-password?return_url=${encodeURIComponent(returnUrl)}`);
  }, []);

  return (
    <main style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24 }}>
      <Spin size="large" />
      <div style={{ color: '#666' }}>Переход в центр восстановления пароля…</div>
    </main>
  );
};

export default ForgotPassword;
